import { DarkModeSwitch as ComponentLibraryDarkModeSwitch } from "@southfields-digital/mxmz-react-ui";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import type { StateType } from "src/redux/reducers";
import { UISelectors } from "src/redux/reducers/ui/selectors";
import { DARK_MODE_CONFIRMED, TOGGLE_DARK_MODE } from "src/redux/reducers/ui/types";
import playerService from "src/services/player/service";

import styles from "./DarkModeSwitch.module.scss";

const DarkModeSwitch = () => {
	const dispatch = useDispatch();
	const isDarkMode = useSelector((state: StateType) => UISelectors.selectIsDarkMode(state));

	const handleToggle = useCallback(() => {
		const newMode = !isDarkMode;
		dispatch({ type: TOGGLE_DARK_MODE });

		// Send message to player
		playerService.toggleDarkMode(newMode);
	}, [dispatch, isDarkMode]);

	// Listen for player confirmations
	useEffect(() => {
		const onMessage = (event: MessageEvent) => {
			if (event.data.type === "darkModeUpdated") {
				const confirmedMode = event.data.payload.isDarkMode;
				// Update Redux state when player confirms
				dispatch({ type: DARK_MODE_CONFIRMED, payload: { isDarkMode: confirmedMode } });
			}
		};

		window.addEventListener("message", onMessage);
		return () => window.removeEventListener("message", onMessage);
	}, [dispatch]);

	return (
		<div className={styles.Header}>
			<ComponentLibraryDarkModeSwitch onToggle={handleToggle} defaultDarkMode={isDarkMode} />
		</div>
	);
};

export default DarkModeSwitch;
